import Modal from 'react-bootstrap/Modal'
import CloseIcon from '@mui/icons-material/Close';

const BannerPopup = ({ show, banner, handleShow, imageUrl }) => {
    const handleClose = () => {
        handleShow(false)
    }
    return (
        <Modal show={show} closeButton onHide={handleClose} size='lg'>
            <div className='banner-view-stage' style={{
                height: '500px',
                padding: "10px",
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: '#f9fbf7',
                borderRadius: '17px',
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    width: '100%'
                }}>
                    <p dangerouslySetInnerHTML={{ __html: banner.bannerHeader }} style={{
                        fontFamily: "Lato",
                        fontSize: "25px",
                        fontWeight: 600,
                        marginLeft: '60px'
                    }}></p>
                    <div className='clays-sm'>
                        <button className='icon-clay' onClick={handleClose} >
                            <span class="inner-clay color-black"><CloseIcon />
                            </span>
                        </button>
                    </div>
                </div>

                <p dangerouslySetInnerHTML={{ __html: banner.bannerText }} style={{
                    fontFamily: "Lato",
                    fontSize: "18px",
                    fontWeight: 400,
                    marginLeft: '60px'
                }}></p>
                <img src={imageUrl} style={{
                    width: "650px",
                    height: "325px",
                    marginLeft: '60px',
                    borderRadius: "15px",
                    position: 'absolute',
                    top: '120px'
                }} alt="NO IMAGE" />
            </div>
        </Modal>)
}


export default BannerPopup